require('./index.css');

var InputFactory = require('./input-factory');

Enhancer.registerWidget( {
    construct: function( prof, zContext ) {
        this.prof = prof;
        this.inputs = {};
        this.linkageMap = {};
        var that = this;
        that.$div.addClass('enhancer-form')
            .html( prof.formHTML );

        that.$div.find( '>table' ).css( 'font-size', prof.fontSize );

        if ( prof.border === 'none' ) {
            that.$div.find( ' td' ).css( 'border', 'solid 1px transparent' );
        } else {
            that.$div.find( ' td' ).addClass( 'ui-widget-content' );
        }
        that.__bindSourceData(function(sourceData) {
            var wno = that.getWindowNo();
            for ( var i in prof.inputModel ) {
                var model = prof.inputModel[ i ];
                model.form = that;

                // Create input instances.
                that.inputs[ model.name.toUpperCase() ] = InputFactory.create(
                    model.type,
                    model,
                    that.$div.find( 'table td[name=' + model.name + ']' ),
                    zContext
                );

                // Create input linkage map.
                var params = model.source ? model.source.params : [];
                if ( model.bindValue ) {
                    params.push( model.bindValue );
                } 
                for ( var i = 0; i < params.length; i++ ) {
                    if ( new RegExp( '^' + wno + '-' ).test( params[i] ) ) {
                        var motivation = (params[i].split('-')[1]).toUpperCase();
                        var linkList = that.linkageMap[motivation] || [];
                        linkList.push( model.name );
                        that.linkageMap[ motivation ] = linkList;
                    }
                }
            }
            var isComplete = {};

            for ( var i in that.inputs ) {
                isComplete[i] = false;
            }
            function isAllComplete() {
                for ( var i in isComplete ) {
                    if ( !isComplete[i] ) {
                        return false;
                    }
                }
                return true;
            }
            // Call initData sperated from input creation.
            for ( var i in that.inputs ) {
                ( function(k) {
                    that.inputs[k].initData( zContext, function() {
                        isComplete[k] = true;
                        // Trigger form complete event, when all input data is ready.
                        if ( isAllComplete() ) {
                            that.trig( 'complete' );
                        }
                    } );
                } )(i);
            }
        } );
    },
    __bindSourceData: function( callback ) {
        var that = this;
        if (that.prof.source) {
            that.getSourceData( that.prof.source.id, {
                format: 'default'
            }, function( data ) {
                var sourceData = data[0];
                if (sourceData) {
                    for (var i in sourceData) {
                        sourceData[i.toLowerCase()] = sourceData[i];
                    }
                }
                that.sourceData = sourceData;
                callback( that.sourceData );
            } );
            return;
        }
        callback();
    },
    getFieldSourceData: function( fieldName ) {
        return this.sourceData
            ? this.sourceData[fieldName.toLowerCase()]
            : undefined;
    },
    getData: function() {
        var data = {
            'input_number': this.getProfile().inputModel.length,
            'last_focus_input_name': this.getLastFocusInputName(),
            'last_focus_input_value': this.getLastFocusInputValue()
        };
        var inp;
        for ( var i in this.inputs ) {
            inp = this.inputs[ i ];
            if (!inp) {
                console.error( 'No input instance for ' + i );
                continue;
            }
            data[ i ] = inp.getTypedValue();
            if ( typeof inp.getDisplayName === 'function' ) {
                data[ i + '_display_name' ] = inp.getDisplayName();
            }
        }
        return data;
    },

    isReady: function() {
        var isReady = true;
        for (var i in this.inputs) {
            if (!this.inputs[i].check()) {
                isReady = false;
            }
        }
        return isReady;
    },
    
    affected: function( zContext ) {
        var that = this;
        var source = that.prof.source;

        // If source data needs to be refresh, rebind source data
        // and then affect each input to refresh value.
        if (source) {
            that.__bindSourceData( function() {
                var inp;
                for ( i in that.inputs  ) {
                    inp = that.inputs[ i ];
                    inp.affected( zContext );
                }
            } );
            return;
        }
        // Else affect each input directly.
        var inp;
        for ( i in that.inputs  ) {
            inp = that.inputs[ i ];
            inp.affected( zContext );
        }
    },
    linkage: function( inputName ) {
        var zContext = this.getZContext(); // <--  defined by super class.
        zContext.merge( this.context() );
        this.setZContext( zContext );
        var linkList = this.linkageMap[ inputName.toUpperCase() ] || [];
        var input;
        for ( var i = 0; i < linkList.length; i++ ) {
            input = this.getInput(linkList[i]);
            if (input) {
                input.affected( zContext );
            }
        }
    },
    destroy: function() {   
    },
    getInput: function( name ) {
        return this.inputs[ name.toUpperCase() ];
    },
    setLastFocusInputName: function( name ) {
        this.lastFocusInputName = name;
    },
    getLastFocusInputName: function() {
        return this.lastFocusInputName || null;
    },
    getLastFocusInputValue: function() {
        if (this.lastFocusInputName) {
            var inp = this.getInput(this.lastFocusInputName);
            if (inp) {
                return inp.getTypedValue();
            }
        }
        return null;
    },
    trigInputEvent: function( inputName, eventName ) {
        this.trig( inputName + 'On' + eventName );
        if (eventName === 'Change' || eventName === 'Check') {
            this.trig( 'formOnChange' );
        }
    }
} );



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0